import { render, staticRenderFns } from "./FulfilledDemandsUpload.vue?vue&type=template&id=468ed70a&scoped=true&"
import script from "./FulfilledDemandsUpload.vue?vue&type=script&lang=ts&"
export * from "./FulfilledDemandsUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468ed70a",
  null
  
)

export default component.exports